import React from 'react';

import {
  formatAge,
  getAgeClass,
  getSeverity,
} from '@totem/components/services/threats/eventsDashboard/report/severity';

import './eventsReport.css';

export const SeverityPill = ({ severity }: { severity: number }) => {
  const details = getSeverity(severity);
  return (
    <span
      styleName="pill"
      style={{ background: `${details.color}22`, color: details.color }}
    >
      <span styleName="dot" style={{ background: details.color }} />
      {details.label}
    </span>
  );
};

export const StatusPill = ({
  status,
  hasTicket,
}: {
  status: string;
  hasTicket: boolean;
}) => {
  if (status === 'CLEARED') {
    return <span styleName="status status-resolved">Resolved</span>;
  }
  if (hasTicket) {
    return <span styleName="status status-ticket">Ticket opened</span>;
  }
  if (status === 'ACKNOWLEDGED') {
    return <span styleName="status status-ticket">Acknowledged</span>;
  }
  return <span styleName="status status-open">Open</span>;
};

export const AgePill = ({
  days,
  suffix = '',
}: {
  days: number;
  suffix?: string;
}) => (
  <span styleName={`age ${getAgeClass(days)}`}>
    {formatAge(days)}
    {suffix}
  </span>
);
